import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        borderBottomColor: '#bff0fd',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 24,
    },
    description: {
        width: '60%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        justifyContent: 'space-between',
        flexDirection: 'row',
        paddingHorizontal: 10


        // paddingLeft: 40,

    },
    urdudescription: {

        fontFamily: 'NotoNastaliqUrdu',
        fontSize: 14
    },
    engdescription: {

        fontSize: 14
    },
    qty: {
        width: '15%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
        borderLeftColor: borderColor,
        borderLeftWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
    rate: {
        width: '15%',
        borderLeftColor: borderColor,
        borderLeftWidth: 1,
        textAlign: 'center',
        paddingRight: 8,
    },
    amount: {
        width: '20%',
        textAlign: 'center',
        paddingRight: 8,
    },
});


const InvoiceTableRow = ({ items = [] }) => {
    const rows = items.map((item, index) =>
        <View style={styles.row} key={item.id.toString()}>
           <Text style={styles.amount}>{(item.quantity * parseFloat(item.price.toString().replace(/,/g, ''))).toLocaleString()}</Text>
            <Text style={styles.rate}>{item.price}</Text>
            <Text style={styles.qty}>{(parseFloat(item.quantity+"").toFixed(2))}</Text>
            <View style={styles.description}>
                <Text style={styles.englishdescription}>{' '}</Text>
                <Text style={styles.urdudescription}>{item.name_urdu}</Text>
            </View>
            <Text style={styles.qty}>{index + 1}</Text>
        </View>
    )
    return (<Fragment>{rows}</Fragment>)
};

export default InvoiceTableRow